import React, { useState, useEffect } from 'react';
import Preloader from '../../general/Preloader';

const PaymentCompleted = (props) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoaded, setIsLoaded] = useState(true);
    const [data, setData] = useState(null);
    let url_fetch = "";

    if (Object.keys(props.user).length != 0){
        url_fetch = `/api/v1/validate_last_user_payment/${props.price.id}/${Number(props.user.id)}`
    }else{
        url_fetch = `/api/v1/validate_last_user_payment/${props.price.id}`
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        fetch(url_fetch, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json",
                "authorization": "98a2425c7cd22d4dad50"
            }
        })
        .then(response => response.json())
        .then(data => {
            setData(data.data);
            setIsLoaded(false);
        });
    }

    return (
        <React.Fragment>
            <div className="card mt-3">
                <div className="card-body">
                    {!isLoaded ? (
                        <React.Fragment>
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <img src={data.image} alt="imagen" height={200} />
                                </div>

                                <div className="col-md-12 text-center mb-4">
                                    <h3 className='text-primary mb-2'>{data.title}</h3>
                                    <p className='text-center mb-0'><b>{data.sub_title}</b></p>
                                </div>

                                <div className="col-md-12">
                                    <hr />
                                </div>

                                <div className="col-md-12 text-center">
                                    <a
                                        className='btn btn-primary text-white'
                                        href='/'
                                    >
                                        Ir a mis cursos
                                    </a>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <div className="text-center">
                            <Preloader/>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}


export default PaymentCompleted;
